import React from 'react';
import { Checkbox, Typography } from '../Layout';
import InfoTooltip from '../InfoTooltip';
import { TitleH3, TitleSpan, gridItemStyle, checkboxStyle } from '../CreateDeviceContent/styles';
import i18n from '../../helpers/i18n';

function PasswordConfigAccessFlag({ formik, controlsDisabled }) {
    return (
        <div style={checkboxStyle}>
            <Checkbox
                label={i18n.t('pages.newDevice.passwordConfigAccess')}
                checked={formik.values.hide_password_config_access}
                onChange={(event) => formik.setFieldValue('hide_password_config_access', event.target.checked)}
                disabled={controlsDisabled}
            />
            <InfoTooltip tooltip={i18n.t('pages.newDevice.passwordConfigAccessDescription')} />
        </div>
    );
}

function ReconfigureMultiFlag({ formik, controlsDisabled }) {
    return (
        <div style={checkboxStyle}>
            <Checkbox
                label={i18n.t('pages.newDevice.reconfigureMulti')}
                checked={formik.values.hide_reconfigure_multi}
                onChange={(event) => formik.setFieldValue('hide_reconfigure_multi', event.target.checked)}
                disabled={controlsDisabled}
            />
            <InfoTooltip tooltip={i18n.t('pages.newDevice.reconfigureMultiDescription')} />
        </div>
    );
}

function PunchReceiptDisplayTimeFlag({ formik, controlsDisabled }) {
    return (
        <div style={checkboxStyle}>
            <Checkbox
                label={i18n.t('pages.newDevice.punchReceiptDisplayTime')}
                checked={formik.values.hide_punch_receipt_display_time}
                onChange={(event) => formik.setFieldValue('hide_punch_receipt_display_time', event.target.checked)}
                disabled={controlsDisabled}
            />
            <InfoTooltip tooltip={i18n.t('pages.newDevice.punchReceiptDisplayTimeDescription')} />
        </div>
    );
}

export default function ButtonDisplaySection({ formik, deviceArchived, permissions }) {
    const controlsDisabled = deviceArchived || formik.values.device_for_receipt_flag_multi;

    // Verifica se é tipo 'ahgora_multi_device'
    const isMultiDevice = formik.values.deviceType === 'ahgora_multi_device';
    
    // Verifica se múltiplos colaboradores estão selecionados
    const hasMultipleCollaborators = 
        (formik.values.collaboratorsType === 'by_employee' && formik.values.employees.length > 1) ||
        (formik.values.collaboratorsType === 'by_location' && formik.values.locations.length > 0);
    
    // Só renderiza se for Multi device E tiver múltiplos colaboradores
    if (!isMultiDevice || !hasMultipleCollaborators) {
        return null;
    }

    return (
        <div style={gridItemStyle}>
            <div style={{ alignItems: 'center', display: 'flex', gap: '8px' }}>
                <TitleH3>
                    {i18n.t('pages.newDevice.buttonDisplayTitle')} <TitleSpan>{i18n.t('pages.newDevice.optional')}</TitleSpan>
                </TitleH3>
            </div>
            <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                {i18n.t('pages.newDevice.buttonDisplaySubtitle')}
            </Typography>
            
            <ReconfigureMultiFlag formik={formik} controlsDisabled={controlsDisabled} />
            <PunchReceiptDisplayTimeFlag formik={formik} controlsDisabled={controlsDisabled} />
            {!permissions?.disable_password_requeriment && (
                <PasswordConfigAccessFlag formik={formik} controlsDisabled={controlsDisabled} />
            )}
        </div>
    );
}